const loading1 = require("./animations/loader1.json");

const options = {
  loading1,
};

export default options;
